import { createContext } from "react";

export const TeamsFxContext = createContext({
  theme: undefined,
  themeString: "",
  teamsUserCredential: undefined,
  apiUrl: "https://aion-asa.com/api/mapei/" 
});
